// src/api/facturas.js
import api from "./config.js";

    // 🧾 Obtener todas las facturas
    export const getFacturas = async () => {
    const { data } = await api.get("/facturas");
    // Aseguramos formato consistente con tu backend (array o envoltorio)
    return Array.isArray(data) ? data : data.facturas || [];
    };

    // 🧾 Obtener una factura por ID
    export const getFactura = async (id) => {
    const { data } = await api.get(`/facturas/${id}`);
    return data;
    };

    // 🧾 Crear una nueva factura
    export const createFactura = async (factura) => {
    const { data } = await api.post("/facturas", factura);
    return data;
    };

    // 🧾 Actualizar una factura existente
    export const updateFactura = async (id, factura) => {
    const { data } = await api.put(`/facturas/${id}`, factura);
    return data;
    };

    // 🧾 Eliminar una factura
    export const deleteFactura = async (id) => {
    const { data } = await api.delete(`/facturas/${id}`);
    return data;
    };
